
<template>
  <v-btn
    class="subtitle-1 text-none"
    active-class="underline"
    type="submit"
    title="Выйти"
    text
    plain
    @click.stop="exitClicked = true"
  >
    <!-- <v-icon> mdi-logout </v-icon> -->
    Выход
    <confirm-exit-dialog v-model="exitClicked"></confirm-exit-dialog>
  </v-btn>
</template>


<script>
import ConfirmExitDialog from "./ConfirmExitDialog.vue";
export default {
  components: {
    ConfirmExitDialog,
  },
  data: () => ({
    exitClicked: false,
  }),

  methods: {
    logout: function () {
      // localStorage.removeItem("token");
      this.$store
        .dispatch("logout")
        .then(() => {
          // console.log("logouting");
        })
        .catch((err) => console.log(err));
    },
  },
  beforeRouteLeave(to, from, next) {
    const answer = window.confirm(
      "Do you really want to leave? you have unsaved changes!"
    );
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
};
</script>
